<template>
  <div>
    <!-- Loading screen -->
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>

    <div v-if="showMaintenanceToolbar()" class="p-col-12 p-mt-2 bg-warning">

      <Dropdown v-model="selectedUser" :options="users" optionLabel="getUserName" placeholder="Wähle einen User"
                v-on:change="switchUser"
                :showClear="true">

        <template #value="slotProps">
          <div v-if="slotProps.value">
            <div>{{ getUserName(slotProps.value) }}</div>
          </div>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </template>

        <template #option="slotProps">
          <div>
            <div>{{ getUserName(slotProps.option) }}</div>
          </div>
        </template>

      </Dropdown>

    </div>

    <div class="p-grid" v-responsive.md.lg.xl>

      <div class="p-col-4">
        <SeasonList @select-match-day="setSelectedMatchDay"></SeasonList>
      </div>

      <div class="p-col-8">
        <UserMatchList :match-day-number="selectedMatchDay"></UserMatchList>
      </div>

    </div>

    <!--
      For small devices
    -->
    <div class="p-grid" v-responsive.sm.xs>

      <div class="p-col-12 p-mt-2">
        <SeasonList @select-match-day="setSelectedMatchDaySm" :hidden="userMatchListVisible"></SeasonList>
      </div>

      <div class="p-col-12">
        <UserMatchList @back-to-match-day-list="showMatchDayListOnly"
                       :match-day-number="selectedMatchDay"
                       :hidden="matchDayListVisible"></UserMatchList>
      </div>

    </div>

  </div>

</template>

<script>
import UserService from '../services/user.service';
import UserMatchList from "../components/UserMatchList";
import SeasonList from '../components/SaisonList';
import Loading from "vue-loading-overlay";

export default {
  name: 'User',
  components: {
    Loading,
    UserMatchList: UserMatchList,
    SeasonList: SeasonList
  },
  data() {
    return {
      content: '',
      selectedUser: null,
      users: [],
      selectedMatchDay: this.$store.state.sys.matchDay,
      matchDayListVisible: true,
      userMatchListVisible: false,
      isLoading: false,
      fullPage: true,
    };
  },
  methods: {
    setSelectedMatchDay(day) {
      // console.log("Day: --->" + day);
      this.selectedMatchDay = day;
    },
    setSelectedMatchDaySm(day) {
      this.matchDayListVisible = false;
      this.userMatchListVisible = true;
      this.selectedMatchDay = day;
    },
    showMatchDayListOnly() {
      this.matchDayListVisible = true;
      this.userMatchListVisible = false;
    },
    showMaintenanceToolbar() {
      return this.$store.state.sys.isMaintenance && this.isAdmin;
    },
    getUserName(data) {
      if (data != null) {
        return data.surname + ", " + data.name;
      }
      return "";
    },
    switchUser() {
      if (this.selectedUser !== null) {
        // console.log("Switch User" + JSON.stringify(this.selectedUser));
      }
      this.$store.dispatch('sys/switchMaintenanceUser', this.selectedUser);
    },
    getUserList() {
      this.isLoading = true;
      UserService.getUserBasicList()
          .then(users => {
            // console.log(JSON.stringify(users));
            this.users = users.data;
          })
          .catch(err => {
            console.log(err);
            this.isLoading = false
          })
    }
  },
  computed: {
    currentMatchDay() {
      return this.$store.state.sys.matchDay;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }
      return false;
    }
  },
  mounted() {
    // check if season year and match day are set
    this.isLoading = true;
    UserService.getUserBasicList()
        .then(users => {
          this.users = users.data;
          if (this.$store.state.sys.maintenanceUser !== null) {
            this.selectedUser = this.$store.state.sys.maintenanceUser;
          }
          return UserService.getUserBoard();
        })
        .then(response => {
          this.content = response.data;
          return this.$store.dispatch('sys/checkMode');
        })
        .then(() => {
          return this.$store.dispatch('sys/getCurrentSeasonYear');
        })
        .then(() => {
          return this.$store.dispatch('sys/getCurrentMatchDay');
        })
        .then(() => {
          this.selectedMatchDay = this.$store.state.sys.matchDay;
          this.$store.dispatch('sys/getSubscription');
          console.log("getUserBoard");
          this.isLoading = false
        })
        .catch(error => {
          console.log("StatusCode: " + error.response.status);
          if (error.response.status === 401) {
            this.content = "Du bist nicht eingeloggt!";
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
          } else {
            this.content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
          }
          this.isLoading = false
        });
  } // end mounted()
};
</script>

<style>
.bg-warning {
  background-color: red !important;
}

.p-dropdown:not(.p-disabled).p-focus {
  box-shadow: 0 0 0 0 !important;
}
</style>